module.exports = __webpack_public_path__ + "answer.png?1b798628cf10a1df1a51069e3430f217";


//////////////////
// WEBPACK FOOTER
// ./static/assets/answer.png
// module id = 524
// module chunks = 0